/** `?action=deploy` on the canvas route auto-opens UnifiedWebPlacementFlow once (AC-012, DC-18). */
export const DEPLOY_ACTION_PARAM = 'action';
export const DEPLOY_ACTION_VALUE = 'deploy';

export function isDeployActionRequested(search: string): boolean {
  return new URLSearchParams(search).get(DEPLOY_ACTION_PARAM) === DEPLOY_ACTION_VALUE;
}

/**
 * Identifies the specific arrival that carried `?action=deploy` (fix round 1):
 * the once-guard in `OnboardingEditorActionsV2` must be scoped to THIS URL, not
 * to the component's mount lifetime — otherwise an editor instance that survives
 * a route-param change to a different `onboardingId` (no remount) would silently
 * swallow a later, legitimate `?action=deploy` because the boolean guard was
 * already flipped by the first onboarding's deploy intent.
 */
export function buildDeployActionKey(onboardingId: string, search: string): string {
  return `${onboardingId}|${search}`;
}
